module.exports = __webpack_public_path__ + "img/9788993094404.97b564f3.jpg";